import React from 'react';
import style from './description.module.css'
import logo_silver from './logo_silver.png'

const Description = () => {
    return (
        <section className={style.container}>
            <div className={style.imgBox}>
                <img className={style.img} src={logo_silver}/>
            </div>
            <div className={style.contactInfo}>
                <h2 className={style.h2}>Об Инжинерных Работах</h2>
                <p className={style.p}>
                    "ТриоСтройИнжиниринг" — это высококвалифицированная команда из более чем 350 специалистов, работающих на строительном рынке с 2013 года. Мы предлагаем комплексные решения в области управления строительными проектами и широкий спектр строительно-монтажных работ. Наши услуги охватывают все этапы строительства, от проектирования до ввода объектов в эксплуатацию.<br/> <br/>
                    Наша география включает Центральный и Южный регионы России, такие как Москва и Московская область, Перми, Сочи, Казань и Красноярский край.
                    Услуги:
                </p>
                <h3 className={style.h3}>Направления нашей компании:</h3>
                <p className={style.p}>
                    -   Комплексное управление строительством<br/><br/>
                    -   Обеспечение высокого качества строительства собственными силами<br/><br/>
                    -   Технический надзор за выполнением работ<br/><br/>
                    -   Разработка технического задания и проектирование строительных мероприятий<br/><br/>
                    -   Подбор подрядчиков и специалистов<br/><br/>
                    -   Получение всех необходимых разрешений и согласований<br/>
                </p>
            </div>
        </section>
    )
}
export default Description